import { render } from "./PlayerPointsDetails.vue?vue&type=template&id=fb8d84a8&scoped=true"
import script from "./PlayerPointsDetails.vue?vue&type=script&lang=js"
export * from "./PlayerPointsDetails.vue?vue&type=script&lang=js"

import "./PlayerPointsDetails.vue?vue&type=style&index=0&id=fb8d84a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb8d84a8"]])

export default __exports__